import { render, staticRenderFns } from "./SendDocument.vue?vue&type=template&id=77f76352&scoped=true"
import script from "./SendDocument.vue?vue&type=script&lang=js"
export * from "./SendDocument.vue?vue&type=script&lang=js"
import style0 from "./SendDocument.vue?vue&type=style&index=0&id=77f76352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f76352",
  null
  
)

export default component.exports